/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-status-m': {
    width: 11,
    height: 9,
    viewBox: '0 0 11 9',
    data: '<path pid="0" d="M3.608.467l2.14 5.693h.026L7.928.467h2.493v1.02l-.415.038c-.252.025-.374.172-.366.441l.315 5.768.781.038v1.07H7.701v-1.02l.453-.037c.227-.017.336-.126.328-.328l-.24-4.446h-.025l-1.94 5.026H5.082L3.167 3.062h-.025L2.89 7.734l.818.038v1.07H.736v-1.02l.453-.037c.194-.017.299-.13.315-.34l.34-5.857-.768-.05V.468h2.532z" _fill="#737373"/>'
  }
})
